<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import LocationIcon from "../components/icons/LocationIcon.svelte";
    import LocationPrices from "./LocationPrices.svelte";

    let regions = null;
    let locations = null;
    let regionId = 0;
    let editLocation = null;
    let initialized = false;
    let pricesComponent;

    const pageHeaderControls = [
        {id: 'save', name: 'SAVE', class: 'hidden-xs'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const load = () => {
        const onSuccess = result => {
            regions = result.filter(x => x.level == 0);

            // get start locations
            let startPoints = result.filter(x => x.is_start_point == 1);
            // get other locations
            locations = result.filter(x => (x.level == 1 && x.is_start_point == 0));
            // add start locations first
            locations = startPoints.concat(locations);

            initialized = true;
        }

        const onFailure = err => {
        };

        R.handle(R.location.index, [], onSuccess, onFailure, LOADER.PAGE);
    }


    const openPrices = (item) => {
        if (editLocation != null) {
            Alert.warning("Location prices", "You are already have an open location for price editing!");
            return;
        }
        editLocation = item;
    }

    const closePrices = () => {
        editLocation = null;
    }

    const onSave = () => {
        if (pricesComponent) {
            pricesComponent.save();
        } else {
            Notifier.showError("There is nothing to save!");
        }
    }

    load();
</script>

<PageHeader title="Transfer Prices" controls={ pageHeaderControls } on:save={onSave} on:reload={load}/>

{#if initialized}
    <div class="row">
        <div class="col-md-4">
            <div class="panel panel-default">
                <div class="panel-heading">
                    Locations
                </div>
                <div class="panel-body panel-pad">
                    <div class="tools-box">
                        <select class="form-select" bind:value="{ regionId }">
                            <option value={0}>all regions</option>
                            {#each regions as region}
                                <option value={ region.id}>{ region.name }</option>
                            {/each}
                        </select>
                    </div>
                </div>
                <table class="table table-list locations">
                    <tbody>
                    {#each locations as item}
                        {#if regionId == 0 || item.parent_id == regionId}
                            <tr class="row-hover" class:row-selected={editLocation && editLocation.id == item.id}>
                                <td class="name">
                                    <LocationIcon name="{ item.type_id }" size="14" cssClass="me-2"/>
                                    <button class="btn-reset is-link" class:not-active={ item.is_active < 1}
                                            on:click="{ () => openPrices(item) }">
                                        { item.name }
                                    </button>
                                </td>
                                <td class="code text-gray">
                                    {item.code}
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-8">
            {#if editLocation}
                <LocationPrices bind:this={pricesComponent} location={editLocation} all_locations={locations} onClose={closePrices}/>
            {/if}
        </div>
    </div>
{/if}


<style>
    .locations tr > td.name {
        display: flex;
        align-items: center;
    }

    :global(.locations tr>td.name .location-icon) {
        color: #ccc;
    }
</style>